import { ViewModel,View, ObservableArray } from "binder"
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import { ListPropertyType, TemplateSelectorPropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";
import { ITemplateSelector } from "src/uicomponents/components/templateSelector";
import  { ListView } from "./list-view"

export class ListComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'List';
        this.canAcceptContent = false;
        this.addProperty("ItemsSource","data-b-comp-items",new ListPropertyType(this),null,false);
        this.addProperty("ItemTemplateSelector","data-b-comp-templateselectorfunction",new TemplateSelectorPropertyType(this),"",false);
    }
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new ListViewModel(parent);
        return result;
    }
        
    protected getClassDefaultValue(){
        return "list";
    }

}
export class ListViewModel extends FormBuilderElement{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    public set ItemsSource(v: ObservableArray<ViewModel>) { this._ItemsSource = v; } public get ItemsSource(): ObservableArray<ViewModel> { return this._ItemsSource;} private _ItemsSource: ObservableArray<ViewModel>;
    public set TemplateSelector(v: ITemplateSelector) { this._TemplateSelector = v; } public get TemplateSelector(): ITemplateSelector { return this._TemplateSelector;} private _TemplateSelector: ITemplateSelector;
    public set ItemTemplateSelector(v: string) { this._ItemTemplateSelector = v; } public get ItemTemplateSelector(): string { return this._ItemTemplateSelector;} private _ItemTemplateSelector: string;

    GetDefaultView(): View <ViewModel> {
        return new ListView();
    }
    public getTypeId(): string {
        return "VM-6DAA7A7C-5D5B-45B6-B2D6-180CC4803A92"
    }

    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitList(this,parameter);
    }

    override onDataContextSet(){
        this.TemplateSelector = this.DataContext._Builder_TemplateSelector__;
    }

    
}
